// JavaScript Document
jQuery(document).ready(function($) {
	  $('#sign-up-bn').on('click', function( evt ) {
 
	  	evt.preventDefault();		  

		//$('#update_panel .info .red').html( '' );		
		//$('#update_panel .info .green').html( '' );			
		
		$('.simpods-mvc-cpd-validates-as-required').each(function(index, element) {
			$('.simpods-mvc-cpd-not-valid-tip').remove();
		});
		
		var passed   = true;
		$('.simpods-mvc-cpd-validates-as-required:not([disabled])').each( function( index, element ) {
			var value 	  = $.trim( $( element ).val() );
			var valid_info_ele =  $( '<span class="simpods-mvc-cpd-not-valid-tip red" role="alert" style="display:none;">Please fill this field.</span>' );
			if( $(this).attr('id') == 't_and_c' ){
				if( ! $(this).is(':checked') ) {
					value = '';
					valid_info_ele =  $( '<span class="simpods-mvc-cpd-not-valid-tip red w100" role="alert" style="display:none;">Please check the box.</span>' );
				}
			}
			
			if( value == '' ){
				
				$(this).parent().parent().append( valid_info_ele );
				valid_info_ele.slideToggle( 'fast', function() {
					// Animation complete.
				});
				passed = false;					
			
			}

		});

		if( passed ){
			var working_ele =  $( '<div class="cpd-info alert alert-warning" role="alert">Signing up. Please wait... </div>' );
			$('#cpd-signing-up').html( working_ele ); 
			$('#sign-up-bn').attr('disabled', 'disabled');
			$('#sign_up_form').submit();	
		}
	});

	/**
	 * https://code.tutsplus.com/articles/using-the-included-password-strength-meter-script-in-wordpress--wp-34736
	 */
	function check_password_strength( $pass1,
									$pass2,
									$strengthResult,
									$submitButton,
									blacklistArray ) {
		var pass1 = $pass1.val();
		var pass2 = $pass2.val();
		// Reset the form & meter
		$submitButton.attr( 'disabled', 'disabled' );
		$strengthResult.removeClass( 'short bad good strong' );

		if ( 0 == pass1.length ){ // Skip check if empty
			$strengthResult.html( pwsL10n.empty );
			return 0;
		}
	 
		// Extend our blacklist array with those from the inputs & site data
		blacklistArray 	= blacklistArray.concat( wp.passwordStrength.userInputBlacklist() )
	 
		// Get the password strength
		var strength 	= wp.passwordStrength.meter( pass1, blacklistArray, pass2 );
	 
	 	var invalid_str	= '';
	 	min_pass_strength	= parseInt( min_pass_strength[0] );
	 	if ( pass1.length < 7 || ( min_pass_strength[0] > strength || 5 == strength ) ) {
	 		invalid_str	= ' (' + pwsL10n.invalid + ')';
	 	} else {
			$submitButton.removeAttr( 'disabled' );
		}
		// Add the strength meter results
		switch ( strength ) {
			case 1:
				$strengthResult.addClass( 'bad' ).html( pwsL10n.bad + invalid_str );
				break;

			case 2:
				$strengthResult.addClass( 'good' ).html( pwsL10n.good + invalid_str );
				break;

			case 3:
				$strengthResult.addClass( 'strong' ).html( pwsL10n.strong + invalid_str );
				break;

			case 4:
				$strengthResult.addClass( 'strong' ).html( pwsL10n.vstrong + invalid_str );
				break;

			case 5:
				$strengthResult.addClass( 'short' ).html( pwsL10n.mismatch  + invalid_str );
				break;

			default:
				$strengthResult.addClass( 'short' ).html( pwsL10n.short  + invalid_str );
		}

		return strength;
	}

    // Binding to trigger check_password_strength
    $( 'body' ).on( 'keyup', '#user_password, #confirm_password',
        function( event ) {
            var strength_int = check_password_strength(
                $('#user_password'),         // First password field
                $('#confirm_password'), // Second password field
                $('#password-strength'),           // Strength meter
                $('#sign-up-bn'),           // Submit button
                ['fuck', 'shit', 'bitch']        // Blacklisted words
           );
			$('#password-strength').removeClass('badge-success');
			$('#password-strength').removeClass('badge-danger');
			$('#password-strength').removeClass('badge-warning');
			$('#password-strength').removeClass('badge-default');
			if ( 4 === strength_int ) {
				 	//$('#register-form-build-comic .hint').html('');
					//$('#password-strength').removeClass('pdt5 pdb5 pdl10 pdr10');
					$('#password-strength').addClass('badge-success');
					
				} else {
					
					$('#sign_up_form .hint').html('<small class="">The password should be at least <b>seven</b> characters long. To make it stronger, use upper and lower case letters, numbers and symbols like ! " ? $ % ^ &amp; ).</small>');
			}
			if (  '' == strength_int  || 1 == strength_int ){
				$('#password-strength').addClass('badge-default');
			}
			if (  2 === strength_int || 5 === strength_int ) {
				$('#password-strength').addClass('badge-danger');
			}
			if ( 3 === strength_int ) {
				$('#password-strength').addClass('badge-warning');
			}			
        }
   );	

	if ( $( '#sign_up_form #username' ).length != 0 ) {
		var past_int = 0;
		var now_int = 0;
		var is_key_up = false;
		// set interval to trigger saving every 2 seconds if keyup
		var check_sil = setInterval( function() {
			// only trigger if after stop typing for 2 seconds
			if ( is_key_up ) {
				if ( now_int - past_int >= 1 ) {
					cpd_check_user( $( '#sign_up_form #username' ).val(), render_feedback );
					is_key_up = false;
				}
			}
			now_int++;
		}, 500 );
		$( '#sign_up_form #username' ).keyup( function() {
			var id_int = $( this ).data( 'id' );
			past_int = now_int;
			is_key_up = true;
			$( '#sign_up_form .email-ok' ).addClass( 'hidden' );
			$( '#sign_up_form .email-wrong' ).addClass( 'hidden' );
		} );
		//$( '#check_email_fb .fb-sites-quest' ).live( 'click', function() {
		$(document.body).on('click', '#check_email_fb .fb-sites-quest', function( evt ){		
			$( '#check_email_fb .fb-sites' ).show( 'fast' );
			$( '#check_email_fb .fb-sites' ).css( {
				'display': 'inline'
			} );
		} );
	}    
	/**
	 * check user logo
	 */
	function cpd_check_user( email_address, callBack ) {
		email_address = $.trim( email_address );
		if ( is_email( email_address ) ) {			
			var data_obj = {};
			data_obj[ 'action' ] 	= 'simpods_cpd_ajax_check_user';
			data_obj[ 'email' ] 	= email_address;
			data_obj[ 'security' ] 	= nonce[0];
			
			$( '#sign_up_form #email-load-img' ).removeClass( 'hidden' );
			$( '#sign_up_form .email-ok' ).addClass( 'hidden' );
			$( '#sign_up_form .email-wrong' ).addClass( 'hidden' ); 
			$.post( 
				ajax_script.ajaxurl, 
				data_obj, 
				function( response_data ) { 
					$( '#sign_up_form #email-load-img' ).addClass( 'hidden' );
					//var return_obj = $.parseJSON( response_json );
					var return_obj = response_data['data'];
				
					if ( return_obj[ 'message' ] == '' ) {
						$( '#sign_up_form .email-ok' ).removeClass( 'hidden' );
					} else {
						$( '#sign_up_form .email-wrong' ).removeClass( 'hidden' );
					}
					if ( callBack ) { 
						if ( return_obj[ 'message' ] !== '' ) {
							$( '#sign-up-bn' ).prop( 'disabled', true );
						} else {
							$( '#sign-up-bn' ).prop( 'disabled', false );
						}
						var html_obj = {
							'#cpd-check-email-fb': return_obj[ 'message' ]
						}; 
						callBack( html_obj );
					}
				} 
			)
		}
	}
	/**
	 * Some odd emails may not valid
	 */
	function is_email( email_address ) {
		var regex = /^([a-zA-Z0-9'_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		return regex.test( email_address );
	}
	/**
	 * function to update html
	 */
	function render_feedback( html_obj ) {
		for ( var k in html_obj ) {
			$( k ).html( html_obj[ k ] );
		}
	}	
});
